import { useBrokerGetContractsApiQuery } from "api/rest/rfp/brokerGetContractsApi/brokerGetContractsApi";
import { mapTransportationModeToMode } from "app/pages/reports-and-analytics/components/reports/ReportsTabContainer";

import { useBrokerBidsIndexSliceSelector } from "../store/brokerBidsIndexStore";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useGetBrokerContracts = () => {
  const { searchQuery, transportationMode } = useBrokerBidsIndexSliceSelector(
    (store) => store.brokerBidsIndexFilterSlice
  );

  return useBrokerGetContractsApiQuery({
    queryParams: { mode: mapTransportationModeToMode[transportationMode], search: searchQuery },
  });
};
